// test1778
(1778 && 0);
